export default __webpack_public_path__ + "images/reg_icon_748f83deb332a17523b22afced42a52d.svg";